<mat-form-field class="full-width-chip-list">
  <mat-label>Compare Counties</mat-label>
  <mat-chip-grid #chipList aria-label="Scope selection">
    @for (scope of selectedScopes; track scope) {
      <mat-chip-row
        (removed)="remove(scope)">
        {{scope}}
        @if (scope!==initialScope) {
          <mat-icon matChipRemove>x</mat-icon>
        }
      </mat-chip-row>
    }
    <input
      data-html2canvas-ignore
      placeholder="New county..."
      #scopeInput
      [formControl]="scopeCtrl"
      [matAutocomplete]="auto"
      [matChipInputFor]="chipList"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      (matChipInputTokenEnd)="add($event)"
      (mousedown)="stopPropagation($event)">
  </mat-chip-grid>
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
    @for (scope of filteredScopes | async; track scope) {
      <mat-option [value]="scope" (click)="add($event)">
        {{scope}}
      </mat-option>
    }
  </mat-autocomplete>
</mat-form-field>
